import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {ResourcesService} from "../../services/resources-service.service";
import {DateRangeTimeFiltersService} from "../../../commons/services/date-range-time-filters.service";

export class resourceAllocationTimelineLogsViewCtrl implements IController {

  allocation: any;

  private timeline;
  private filterConfig;
  private isMobile;

  constructor(private resourcesService: ResourcesService, private dateRangeTimeFiltersService: DateRangeTimeFiltersService, private $mdMedia, private moment) {
  }

  $onInit() {
    this.filterConfig = {
      customTemplates: this.dateRangeTimeFiltersService.getDeliveriesCustomTemplates(),
      range: {
        dateStart: this.moment(this.moment().local().toISOString()).startOf('day').valueOf(),
        dateEnd: this.moment(this.moment().local().toISOString()).endOf('day').valueOf()
      }
    }

    this._getLogsTimeline();
  }

  $doCheck() {
    this.isMobile = !this.$mdMedia('gt-xs');
  }

  $onChanges(changes) {
    if (changes.allocation && !changes.allocation.isFirstChange()) {
      this.allocation = changes.allocation.currentValue;
      this._getLogsTimeline();
    }
  }

  onRangeChanged(range) {
    if (range &&
      (!_.isEqual(range.dateStart, this.filterConfig.range.dateStart) ||
        !_.isEqual(range.dateEnd, this.filterConfig.range.dateEnd))) {

      this.filterConfig.range = range;
      this._getLogsTimeline();
    }
  }

  private _getLogsTimeline() {
    if (this.allocation) {
      this.resourcesService.getLogsTimeline(
        this.allocation.resourceAllocationId,
        _.get(this.filterConfig, 'range.dateStart'),
        _.get(this.filterConfig, 'range.dateEnd')
      )
        .then((timeline) => {
          this.timeline = timeline;
        })
    }
  }

}
angular
  .module('bringoz.admin.resources')
  .component('resourceAllocationTimelineLogsView', {
    bindings: {
      allocation: '<'
    },
    template: require('./resource-allocation-timeline-logs-view.html').default,
    controller: resourceAllocationTimelineLogsViewCtrl
  });
